import { Box, ListItemButton } from "@mui/material"
import { ListItemBox } from "lib/@components/ListItemBox"
import { FolderItemPart } from "routes/schedule/tree/schedules/folder-item-part"
import { FolderIcon } from "routes/schedule/tree/schedules/folder-icon"
import { prevent } from "lib/prevent"
import { useBoundContext } from "lib/@components/binding/use-bound-context"

export function MyTree({ last, Component = ListItemButton }) {
    const { onClick, selected, noDivider } = useBoundContext()
    last = last || noDivider
    return (
        <Component divider={!last} selected={selected} onClick={prevent(onClick)}>
            <ListItemBox spacing={1}>
                <FolderItemPart />
                <FolderItemPart>
                    <FolderIcon icon="pajamas:issue-type-maintenance" sx={{ color: "myStuff.main" }} />
                </FolderItemPart>
                <Box flex={1}>Maintenance Regime</Box>
            </ListItemBox>
        </Component>
    )
}
